import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponent } from './icon.component';
import { PipeModule } from 'app/pipes/pipe.module';

@NgModule({
  imports: [
    CommonModule,
    PipeModule
  ],
  declarations: [IconComponent],
  exports: [IconComponent]
})
export class IconModule { }
